module.exports = __webpack_public_path__ + "img/limited-time-award-3.34826d7a.png";